

<button data-cy="template-picker" id="template-display-button" mat-button [matMenuTriggerFor]="templateHandler" matTooltip="Choose a Template">
  <mat-label class="template-labels" *ngIf="!selectedTemplate">Templates</mat-label>
  <mat-label class="template-labels" *ngIf="selectedTemplate">Template: {{ selectedTemplate.title | slice:0:10 }}...</mat-label>
  <mat-icon class="arrow-drop-down tw-text-blue-400">arrow_drop_down &nbsp;</mat-icon>
</button>

<mat-menu #templateHandler="matMenu" panelClass="template-picker-menu">

    <mat-action-list class="no-margin-button-container" (click)="$event.stopPropagation()">
      <button mat-button class="no-margin-buttons" *ngFor="let group of templateGroupNames" (click)="selectedGroupName(group)">{{ group | titlecase }}</button>
    </mat-action-list>

    <mat-list  class="template-container">
      <mat-list-item class="template-item">
          <mat-radio-button type="radio" name="option" (click)="emitTemplate(null)">Clear Template</mat-radio-button>
      </mat-list-item>
      <mat-list-item class="template-item" *ngFor="let template of selectedTemplateGroup">
          <mat-radio-button type="radio" name="option" (click)="emitTemplate(template)" [checked]="selectedTemplate === template">{{ template.title }}</mat-radio-button>
      </mat-list-item>
    </mat-list>

</mat-menu>


